export * from "./errors";

export const statesConst = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AZ: "Arizona",
  AR: "Arkansas",
  AA: "Armed Forces Americas",
  AE: "Armed Forces Europe, Canada, Africa and Middle East",
  AP: "Armed Forces Pacific",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FM: "Federated States of Micronesia",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  MP: "Northern Mariana Islands",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  MH: "Republic of Marshall Islands",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VI: "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

// Trademark types
export const REGISTER_TRADEMARK_CODE_ARRAY = [
  "TRADEMARK_RegisterTrademark",
  "TRADEMARK_RegisterTrademarkV2",
  "TRADEMARK_RegisterTrademark_Basic",
  "TRADEMARK_RegisterTrademark_Standard",
  "TRADEMARK_RegisterTrademark_Platinum",
];

export const SEARCH_TRADEMARK_CODE_ARRAY = [
  "TRADEMARK_Trademark_Search_Basic",
  "TRADEMARK_Trademark_Search_Global",
  "TRADEMARK_Trademark_Search_Federal_State",
  "TRADEMARK_Trademark_Search_Common_Law",
];

export const includedName = {
  NONE: "None",
  OWNER_NAME: "Owner Name",
  OWNER_NICKNAME: "Owner Nickname",
  OTHER_NAME: "Other Name",
};

export const UPSELL_PRODUCT_CODES = {
  extension: "TRADEMARK_Trademark_Extension",
  statementOfUse: "TRADEMARK_Trademark_Statement_Of_Use",
  renewal: "TRADEMARK_Trademark_Renewal",
  keepTrademarkAlive: "TRADEMARK_Trademark_Keep_Trademark_Alive",
  certifiedCopy: "TRADEMARK_Trademark_Certified_Copy",
  trademarkMonitoring: "TRADEMARK_Trademark_Monitoring",
  revivalFromAbandonment: "TRADEMARK_Trademark_Revival_From_Abandonment",
};

export const PRIVACY_PRODUCTS_CODES = ["TRADEMARK_Private_Contact_Information", "TRADEMARK_Privacy_Package"];

export const ACTION_CODES = {
  officeActionReceived: "OFFICE_ACTION_RECEIVED",
};

export const CUSTOMER_ACTIONS = {
  OAPurchase: "OA_PURCHASE",
  OAHandleExternally: "OA_HANDLE_EXTERNALLY",
  OAAbandon: "OA_ABANDON",
};
